import { type Root, createRoot } from "react-dom/client";

let root: Root | null = null;

export const getRoot = (): Root => {
  const container = document.getElementById("root");
  if (!container) {
    throw new Error("Root container not found");
  }

  if (!root) {
    root = createRoot(container);
  }

  return root;
};
